import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Eyebrow, FadeUp, MaskLines } from "./Reveal";
import { IMG, SERVICES } from "@/data/content";

const SPANS = ["md:col-span-3", "md:col-span-3"];

const Card = ({ s, i }) => {
  const big = true;
  return (
    <FadeUp delay={i * 0.06} className={`${SPANS[i]} min-h-[360px] md:min-h-[520px]`}>
      <Link to={`/services#${s.slug}`} data-testid={`service-card-${s.slug}`}
        className="group relative block h-full overflow-hidden rounded-3xl bg-[#0A192F] text-white">
        <img src={IMG[s.img]} alt={s.title} className="absolute inset-0 h-full w-full object-cover opacity-60 transition-[transform,opacity] duration-[1.2s] ease-out group-hover:scale-105 group-hover:opacity-45" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A192F] via-[#0A192F]/50 to-[#0A192F]/10" />
        <div className="relative h-full p-6 md:p-8 flex flex-col justify-between">
          <div className="flex justify-between items-start">
            <span className="font-mono-x text-sm text-sky-300">{s.no}</span>
            <span className="w-11 h-11 rounded-full border border-white/30 grid place-items-center transition-[transform,background-color] duration-500 group-hover:rotate-45 group-hover:bg-sky-400 group-hover:border-sky-400 group-hover:text-[#0A192F]"><ArrowUpRight size={18} /></span>
          </div>
          <div>
            <h3 className={`${big ? "text-3xl md:text-5xl" : "text-2xl md:text-3xl"} font-bold tracking-tight`}>{s.title}</h3>
            <p className="mt-3 max-w-md text-slate-200 text-sm md:text-base leading-relaxed">{s.short}</p>
          </div>
        </div>
      </Link>
    </FadeUp>
  );
};

export const ServicesBento = () => (
  <section data-testid="services-section" className="bg-[#F8FAFC] py-24 md:py-36">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid md:grid-cols-12 gap-8 items-end mb-14 md:mb-20">
        <div className="md:col-span-7">
          <Eyebrow>What we do</Eyebrow>
          <MaskLines className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-[-0.04em] leading-[0.95] text-[#0A192F]"
            lines={["Two ways we", <>show up for <span className="font-serif-i font-normal tracking-normal text-sky-700">people.</span></>]} />
        </div>
        <FadeUp className="md:col-span-5 md:pb-2">
          <p className="text-slate-600 text-base md:text-lg leading-relaxed">From a single night shift on a busy ward to years of complex care at home — the same standards, the same local people.</p>
        </FadeUp>
      </div>
      <motion.div className="grid md:grid-cols-6 md:auto-rows-[minmax(270px,auto)] gap-4 md:gap-5">
        {SERVICES.map((s, i) => <Card key={s.slug} s={s} i={i} />)}
      </motion.div>
    </div>
  </section>
);
